// extracted by mini-css-extract-plugin
export default {"wrap":"_G-z","logoContainer":"aH-z","brandImg":"bH-z","logoImg":"cH-z","logoButton":"dH-z"};